import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	Tooltip,
	IconButton,
	TableContainer
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from './ActionButtons';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import SpeedIcon from '@material-ui/icons/Speed';
import { green, pink } from '@material-ui/core/colors';
import { mdiEngine, mdiLock, mdiRadioboxMarked } from '@mdi/js';
import Icon from '@mdi/react';

import dayjs from 'dayjs'

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const Results = ({ className, rows, columns, ...rest }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	// const [data, setData] = React.useState(rows);

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Card
			className={clsx(classes.root, className)}
			{...rest}
			elevation={0}
		>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										// align={column.align}
										style={{
											width: column.width
										}}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody id={'rnd-ignore-drag'}>
							{
								rows && rows !== undefined && rows.length !== 0 && rows !== null ?
									rows
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row) => {
											if (row.removed) return null;
											return (
												<TableRow hover key={row._id}>
													{columns.map((column) => {
														if (column.field === 'info') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		{/* <Tooltip title={row.tracker && row.tracker.status.length > 0 ? row.tracker.status[0].speed : ''} >
																			<IconButton
																				size='small'
																				disabled={!row.tracker || row.tracker.status.length === 0}
																			>
																				<SpeedIcon />
																			</IconButton>
																		</Tooltip> */}
																		<Tooltip title={row.tracker && row.tracker.status.length > 0 && row.tracker.status[0].io.ignition ? 'Ignition On' : 'Ignition Off'}>
																			<IconButton
																				size='small'
																				disabled={!row.tracker || row.tracker.status.length === 0}
																			>
																				<Icon path={mdiEngine} size={1} style={row.tracker && row.tracker.status.length > 0 ? row.tracker.status[0].io.ignition ? { color: green[500] } : { color: pink["A400"] } : {}} />
																			</IconButton>
																		</Tooltip>
																		{row?.tracker?.serial.length > 9 && <Tooltip title={row.tracker && row.tracker.status.length > 0 && row.tracker.status[0].io.immobilised ? 'Immobilised' : 'Mobilised'}>
																			<IconButton
																				size='small'
																				disabled={!row.tracker || row.tracker.status.length === 0}
																			>
																				<Icon path={mdiLock} size={1} style={row.tracker && row.tracker.status.length > 0 ? !row.tracker.status[0].io.immobilised ? { color: green[500] } : { color: pink["A400"] } : {}} />
																			</IconButton>
																		</Tooltip>}
																		{/* <Tooltip title={row.tracker && row.tracker.status.length > 0 && row.tracker.connection_events && row.tracker.connection_events.status ? 'Online' : 'Offline'}>
																			<IconButton
																				size='small'
																				disabled={!row.tracker || !row.tracker.connection_events}
																			>
																				<Icon path={mdiRadioboxMarked} size={1} style={row.tracker && row.tracker.status.length > 0 && row.tracker.connection_events ? row.tracker.connection_events.status ? { color: green[500] } : { color: pink["A400"] } : {}} />
																			</IconButton>
																		</Tooltip> */}
																	</TableCell>
																</>
															)
														}
														if (column.field === 'reginfo') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		{withTooltip(`${row.type} - ${row.registration_number} - ${row.registration_state}`, column.width)}
																		{/* {`${row.type} - ${row.registration_number} - ${row.registration_state}`} */}
																	</TableCell>
																</>
															)
														}
														if (column.field === 'actions') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		<ActionButton row={row} />
																	</TableCell>
																</>
															)
														}
														const value = row[column.field];
														// console.log(row?.tracker?.status[0]?.position_timestamp);
														return (
															<TableCell align={column.align} width={column.width}>
																{withTooltip(value, column.width)}
																<Typography variant="caption" display="block" style={{ color: 'grey' }}>
																	Last seen: {row?.tracker?.status[0]?.position_timestamp ? dayjs(row?.tracker?.status[0]?.position_timestamp).fromNow() : "Never"}
																</Typography>
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <Typography>No Vehicles Found</Typography>
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</div>
		</Card>
	);
};

Results.propTypes = {
	className: PropTypes.string,
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
};

export default Results;
